<gp-table class="table">
  <tbody>
  <tr *ngIf="(!data || data.length === 0) else whenData">
    <td colspan="100%" class="text-center">
      {{ 'COMMON.no_table_data' | translate }}
    </td>
  </tr>

  <ng-template #whenData>
    <div *ngFor="let datum of data" class="card-container m-b-sm">
      <div class="card-header" (click)="datum.isExpanded = !datum.isExpanded">
        <span [tooltip]="'PersonLog.Status.' + datum.status + '.Since' | translate: {
                    since: datum.updateDate | gpDate: {withTime: true}
                  }"
              [placement]="'right'"
              [adaptivePosition]="true"
              [containerClass]="
                datum.status === 'IN_PROGRESS' ? 'tooltip-info' :
                datum.status === 'FAILED' ? 'tooltip-danger' :
                'tooltip-success'"
              class="status"
              [class.sdc-failed]="datum.status === 'FAILED'"
              [class.sdc-success]="datum.status === 'SUCCESS'"
              [class.sdc-pending]="datum.status === 'IN_PROGRESS'">
          {{ ('SDC.' + datum.status) | translate }}
        </span>

        <div class="header-actions">
          <span class="date-range text-nowrap" *ngIf="datum.values?.['startDate'] && datum.values?.['endDate']">
              {{ datum.values['startDate'] | dateInfinity }} → {{ datum.values['endDate'] | dateInfinity }}
          </span>
          <button type="button"
                  class="arrow-btn"
                  (click)="datum.isExpanded = !datum.isExpanded; $event.stopPropagation()">
            <i class="fa"
               [class.fa-chevron-down]="!datum.isExpanded "
               [class.fa-chevron-up]="datum.isExpanded "></i>
          </button>
        </div>
      </div>

      <div *ngIf="datum.isExpanded" class="card-details">
        <div class="details-grid" *ngIf="datum.values as values">
          <div class="detail-item" *ngFor="let field of standardFields">
            <div class="detail-label">{{ field }}</div>
            <div class="detail-value">{{ values[field] || '-' }}</div>
          </div>

          <div class="detail-item" *ngFor="let field of additionalFields">
            <div class="detail-label">{{ field }}</div>
            <div class="detail-value">{{ values[field] || '-' }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  </tbody>
</gp-table>
